<template>
  <header>
    <div class="flex flex-col lg:flex-row lg:items-baseline w-full lg:justify-between md:px-2 mt-[18px] md:mt-0">
      <form @submit.prevent="onSearchSubmit" class="mb-2 lg:w-[429px] h-[36px]">
        <div class="relative" pt:root:class="m-5 bg-emerald-500">
          <v-icon name="hi-search"
            class="pi pi-search !absolute !left-4 !top-[50%] translate-y-[-50%] w-[20px] h-[20px] text-gray-400" />
          <InputText :placeholder="$t('labels.generic', {
        pt: 'Pesquisar por Título ou Capítulo',
        en: 'Search by Title or Chapter',
      })
        " v-model="searchInputText" class="!h-[36px] !pl-10 !p-[8px] !shadow-yellow-300" />
        </div>
      </form>
      <RouterLink :to="`/${courseName}/${courseId}/forum/create`"
        class="bg-h-primary-500 my-2 px-[8px] rounded flex items-center justify-center text-white font-bold w-[160px] h-[32px] box-border">
        {{
        $t("labels.generic", {
          pt: "Criar novo tópico",
          en: "Create new topic",
        })
      }}
      </RouterLink>
    </div>
    <div class="md:px-2 lg:flex lg:justify-between lg:items-baseline">
      <div class="font-bold text-[20px] my-2">

        <p class="text-[20px] leading-[28.5px]" v-if="searchInput && totalTopics! !== 1">
          {{ totalTopics }}

          {{
        $t("labels.generic", {
          pt: "tópicos publicados sobre",
          en: "topics published about",
        })
      }}
          "{{ searchInput }}"
          {{ topicExploredMessage }}
        </p>
        <p class="text-[20px] leading-[28.5px]" v-else-if="searchInput">
          {{ totalTopics }}
          {{
        $t("labels.generic", {
          pt: "tópico publicado sobre",
          en: "topic published about",
        })
      }}
          "{{ searchInput }}"
          {{ topicExploredMessage }}
        </p>
        <p class="text-[20px] leading-[28.5px]" v-else-if="totalTopics! !== 1">
          {{ totalTopics }}
          {{
        $t("labels.generic", {
          pt: "tópicos publicados",
          en: "topics published",
        })
      }}
          {{ topicExploredMessage }}
        </p>
        <p class="text-[20px] leading-[28.5px]" v-else>
          {{ totalTopics }}
          {{
        $t("labels.generic", {
          pt: "tópico publicado",
          en: "topic published",
        })
      }}
          {{ topicExploredMessage }}
        </p>



      </div>
      <div class="">
        <div class="flex items-center">
          <p class="font-bold text-gray-500">
            <v-icon name="md-sort" :scale="0.8" />
            {{
        $t("labels.generic", {
          pt: "Ordenar por",
          en: "Order by",
        })
      }}
          </p>
          <div class="relative p-1 font-bold hover:border-1">
            <p class="w-full text-h-primary-500">{{ actualOrder.label }}</p>
            <Dropdown v-model="actualOrder" :options="ordenationMenu" optionLabel="label"
              class="!absolute top-0 opacity-0 !p-0 w-full h-full text-h-primary-500"
              panelClass="!p-0 !py-0 !text-left [&_li]:!p-0 [&_li]:!items-left [&_ul]:!py-0 rounded w-[12rem]">
              <template #option="slotProps">
                <button class="!items-left !w-full !h-full !py-1 !pl-1.5 text-xl !text-left"
                  :class="[{ 'p-dropdown-item p-highlight': slotProps.option.label === actualOrder.label }]"
                  @click="slotProps.option.command(slotProps.option)">
                  <div class="!p-0">{{ slotProps.option.label }}

                  </div>
                </button>
              </template>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "header-topics",
  data() {
    return {
      courseName: this.$route.params.courseName,
      courseId: this.$route.params.id,
      actualOrder: this.$route.query?.orderDir === "desc" ?
        {
          label: this.$t("labels.generic", {
            pt: "Mais antigos",
            en: "Oldests",
          }),
          command: () => {
            this.updateOrder("Mais antigos", "desc");
          },
        } :
        {
          label: this.$t("labels.generic", {
            pt: "Mais Recentes",
            en: "Newests",
          }),
          command: () => {
            this.updateOrder("Mais recentes", "asc");
          },
        }

      ,
      ordenationMenu: [
        {
          label: this.$t("labels.generic", {
            pt: "Mais Recentes",
            en: "Newests",
          }),
          command: (optionSelected) => {
            this.updateOrder(optionSelected, "desc");
          },
        },
        {
          label: this.$t("labels.generic", {
            pt: "Mais antigos",
            en: "Oldests",
          }),
          command: (optionSelected) => {
            this.updateOrder(optionSelected, "asc");
          },
        },
      ],
      searchInputText: ""
    };
  },
  props: {
    totalTopics: Number,
    searchInput: String,
    topicExplored: {
      type: Object,
      value: { label: "Todos", query: {} },
    },
  },
  methods: {
    updateOrder(optionSelected: Object, value: string): void {
      this.actualOrder = optionSelected as any;

      this.$emit("onOrderFilter", value);
    },
    onSearchSubmit(): void {
      this.$emit("onSearchTopics", this.searchInputText);
    },
  },
  computed: {
    getSearchInputText(): string {
      return this.searchInputText as string;
    },
    topicExploredMessage() {

      return this.$route.query.status && this.topicExplored?.message ? (this.totalTopics !== 1 ? this.topicExplored?.message + 's' : this.topicExplored?.message) : ''
    },

  },
  watch: {
    searchInput(value) {
      this.searchInputText = value;
    }
  },
});
</script>
